export default __webpack_public_path__ + "static/media/ip.ae00a1ac.svg";